import { publicationsDocumentsProgressReportsArchiveComponent } from './publications-documents-progress-reports-archive.component';
import { ProgressReportsArchiveService } from './publications-documents-progress-reports-archive.service';

export const publicationsDocumentsProgressReportsArchive = angular
    .module('components.publicationsDocumentsProgressReportsArchive', [])
    .component('publicationsDocumentsProgressReportsArchive', publicationsDocumentsProgressReportsArchiveComponent)
    .service('ProgressReportsArchiveService', ProgressReportsArchiveService)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/publications-documents-progress-reports-archive/publications-documents-progress-reports-archive.module.js